// Minnesotaänger Mini App — v1 UI action no-ops.
// New code (not from telegram-tt). Payloads kept from telegram-tt's
// ActionPayloads for structural compatibility; v1 has no notification
// infra, no PWA install banner, and history animations are disabled.

import type { ActionReturnType } from '../../types';
import { addActionHandler } from '../../index';

addActionHandler('showNotification', (): ActionReturnType => undefined);
addActionHandler('setInstallPrompt', (): ActionReturnType => undefined);
addActionHandler('setScrollDownNeeded', (): ActionReturnType => undefined);
addActionHandler('disableHistoryAnimations', (): ActionReturnType => undefined);
